import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import InputMask from 'react-input-mask';
import dayjs from 'dayjs';
import styles from './PointAction.module.sass';
import { pointMovementsSelector, pointsEarnedForYearSelector, tiersSelector } from '../../../selectors/loyalty_program';
import getCurrentTier from '../../../../user/rewards/helpers/get_current_tier';
import Button from '../../../../ui_kit/button/Button';
import ClickableDiv from '../../../../ui_kit/clickable_div/ClickableDiv';
import Input from '../../../../ui_kit/input/Input';
import closeIcon from '../../../../../images/icons/close-bold.svg';
import userApi from '../../../../user/api';
import api from '../../../api';
import { loyaltyProgramActions } from '../../../actions';
import { userObjectSelector } from '../../../../user/selectors/user';
import { modalsActions } from '../../../../modals/actions';
import MODALS from '../../../../modals/constants/modals';
import { userActions } from '../../../../user/actions';

const PAGE_BY_ACTION_TYPE = {
  instagram_follow: 'https://www.instagram.com/volitionbeauty/',
  twitter_follow: 'https://twitter.com/volitionbeauty',
  facebook_like: 'https://www.facebook.com/volitionbeauty/',
};

const HIDE_REDEEM_ACTIONS = [
  'leave_review', 'join_waitlist', 'purchase_product', 'preorder_product',
];

const LEAVE_REVIEW_ACTION_LIMIT = 2;

const CHANGED_ACTION_NAME = {
  preorder_product: 'View Products Available for Pre-Order',
  join_waitlist: 'View Products On the Waitlist',
};

function PointAction(props) {
  const {
    action, tiers, pointsEarnedForYear, clicked,
    setClicked, setPointMovements, setPointsEarnedForYear,
    pointMovements, setPointBalance, user, openJoinTheLoungeModal,
    birthday, setBirthday, setUser, loading, setLoading,
  } = props;
  const currentTier = getCurrentTier(JSON.parse(tiers), pointsEarnedForYear);
  let pointsPerDollar = 1;
  if (currentTier) {
    pointsPerDollar = currentTier.points_per_dollar;
  }

  const {
    image, name, amount, action_type: actionType,
  } = action;

  const redeemed = pointMovements.filter(
    (pointMovement) => pointMovement.action_type === actionType,
  ).length > 0;

  const onActionCompleted = (response) => {
    const {
      point_movements: newPointMovements,
      points_earned_for_year: newPointsEarnedForYear,
      point_balance: newPointBalance,
    } = response.data;

    setPointMovements(newPointMovements);
    setPointsEarnedForYear(newPointsEarnedForYear);
    setPointBalance(newPointBalance);
  };

  const LINKS_BY_ACTION_TYPE = {
    leave_review: '/shop/',
    join_waitlist: '/the-lab/',
    preorder_product: '/the-lab/',
    purchase_product: '/shop/',
  };

  const leaveReviewPointMovements = pointMovements.filter(
    (pointMovement) => pointMovement.action_type === 'leave_review' && dayjs(pointMovement.created_at) > dayjs().subtract('1', 'month'),
  );

  CHANGED_ACTION_NAME.leave_review = (
    `Write a Review
    <span>Leave a before & after photo for 50 extra points!</span>
    (${leaveReviewPointMovements.length}/${LEAVE_REVIEW_ACTION_LIMIT} Redeemed)`
  );

  let birthDayInvalid = true;
  let birthMonthInvalid = true;
  let birthMonth = null;
  let birthDay = null;

  if (actionType === 'celebrate_birthday') {
    const [stringBirthMonth, stringBirthDay] = birthday.split(' / ');
    birthMonth = Number(stringBirthMonth);
    birthDay = Number(stringBirthDay);

    birthMonthInvalid = !birthMonth || birthMonth > 12;

    let maxDaysInMonth = 31;

    if (birthMonth === 2) {
      maxDaysInMonth = 29;
    } else if ([4, 6, 9, 11].includes(birthMonth)) {
      maxDaysInMonth = 30;
    }

    birthDayInvalid = !birthDay || birthDay > maxDaysInMonth;
  }

  const onBirthdaySubmit = () => {
    setLoading(true);
    userApi.updateUser(user.id, { user: { birth_day: birthDay, birth_month: birthMonth } }).then(
      (response) => {
        setUser(response.data);
        setLoading(false);
      },
    );
  };

  return (
    <div className={styles.action}>
      <div className={styles.image}>
        <img src={image} alt={name} />
        { user && (
          <>
            { !clicked && (
              <ClickableDiv className={styles.clickable} onClick={() => setClicked(true)} />
            )}
            { clicked && (
              <>
                <ClickableDiv
                  className={styles.close}
                  onClick={() => {
                    setClicked(false);
                  }}
                >
                  <img src={closeIcon} alt="close" />
                </ClickableDiv>
                <div className={styles.content}>
                  { user.loyalty_program_deactivated_at && (
                    <>
                      <div className={styles.text}>
                        To earn points, opt-in to The Lounge
                      </div>
                      <Button
                        className={styles.button}
                        onClickHandler={() => {
                          setLoading(true);
                          api.reactivateLoyaltyProgram().then((response) => {
                            setUser(response.data);
                            setLoading(false);
                          });
                        }}
                        color="yellow"
                        loading={loading}
                      >
                        JOIN NOW
                      </Button>
                    </>
                  )}
                  { !user.loyalty_program_deactivated_at && (
                    <>
                      <div
                        className={styles.text}
                        dangerouslySetInnerHTML={
                          { __html: CHANGED_ACTION_NAME[actionType] || name }
                        }
                      />
                      { (!redeemed || HIDE_REDEEM_ACTIONS.includes(actionType)) && (
                        <>
                          { PAGE_BY_ACTION_TYPE[actionType] && (
                            <ClickableDiv
                              className={styles.button}
                              onClick={() => {
                                window.open(PAGE_BY_ACTION_TYPE[actionType], '_blank');
                                api.actionCompleted(actionType).then(onActionCompleted);
                              }}
                            >
                              VISIT
                            </ClickableDiv>
                          )}
                          { actionType === 'celebrate_birthday' && user && (!user.birth_day || !user.birth_month) && (
                            <>
                              <InputMask
                                mask="99 / 99"
                                maskPlaceholder="mm / dd"
                                disabled={false}
                                alwaysShowMask
                                value={birthday}
                                onChange={(event) => setBirthday(event.target.value)}
                              >
                                <Input className={styles.input} />
                              </InputMask>
                              { !birthMonthInvalid && !birthDayInvalid && (
                                <Button
                                  className={styles.button}
                                  onClickHandler={onBirthdaySubmit}
                                  color="yellow"
                                  loading={loading}
                                >
                                  UPDATE
                                </Button>
                              )}
                            </>
                          )}
                          { LINKS_BY_ACTION_TYPE[actionType] && (
                            <a
                              className={styles.button}
                              href={LINKS_BY_ACTION_TYPE[actionType]}
                            >
                              GO TO PAGE
                            </a>
                          )}
                          { actionType === 'join_the_lounge' && (
                            <ClickableDiv
                              className={styles.button}
                              onClick={() => {
                                openJoinTheLoungeModal(
                                  `You’ve just received your first ${amount} points for joining.`,
                                );
                                api.actionCompleted('join_the_lounge').then(onActionCompleted);
                              }}
                            >
                              JOIN NOW
                            </ClickableDiv>
                          )}
                        </>
                      )}
                      { redeemed && !HIDE_REDEEM_ACTIONS.includes(actionType) && (
                        <div className={styles.button}>
                          REDEEMED
                        </div>
                      )}
                    </>
                  )}
                </div>
              </>
            )}
          </>
        )}
      </div>
      <div className={styles.name}>
        {name}
      </div>
      <div className={styles.amount}>
        { actionType === 'purchase_product' && (
          `$1 = ${pointsPerDollar} point${pointsPerDollar > 1 ? 's' : ''}`
        )}
        { actionType !== 'purchase_product' && (
          `${amount} Points`
        )}
      </div>
    </div>
  );
}

PointAction.propTypes = {
  action: PropTypes.shape({
    image: PropTypes.string,
    name: PropTypes.string,
    amount: PropTypes.number,
    action_type: PropTypes.string,
  }).isRequired,
  clicked: PropTypes.bool.isRequired,
  setClicked: PropTypes.func.isRequired,
  tiers: PropTypes.string.isRequired,
  pointsEarnedForYear: PropTypes.number.isRequired,
  setPointMovements: PropTypes.func.isRequired,
  setPointsEarnedForYear: PropTypes.func.isRequired,
  setPointBalance: PropTypes.func.isRequired,
  pointMovements: PropTypes.arrayOf(
    PropTypes.shape({
      action_type: PropTypes.string,
    }),
  ).isRequired,
  user: PropTypes.shape({
    id: PropTypes.number,
    birth_day: PropTypes.number,
    birth_month: PropTypes.number,
    loyalty_program_deactivated_at: PropTypes.string,
  }),
  openJoinTheLoungeModal: PropTypes.func.isRequired,
  birthday: PropTypes.string.isRequired,
  setBirthday: PropTypes.func.isRequired,
  setUser: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  setLoading: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  tiers: tiersSelector(state),
  pointMovements: pointMovementsSelector(state),
  pointsEarnedForYear: pointsEarnedForYearSelector(state),
  user: userObjectSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  setPointMovements: (pointMovements) => dispatch(
    loyaltyProgramActions.setPointMovements(pointMovements),
  ),
  setPointsEarnedForYear: (pointsEarnedForYear) => dispatch(
    loyaltyProgramActions.setPointsEarnedForYear(pointsEarnedForYear),
  ),
  setPointBalance: (pointBalance) => dispatch(
    loyaltyProgramActions.setPointBalance(pointBalance),
  ),
  openJoinTheLoungeModal: (description) => dispatch(
    modalsActions.openModalRequest(
      { modal: MODALS.CHECK_OUT_THE_LOUNGE, data: { description, showButton: false } },
    ),
  ),
  setUser: (user) => dispatch(userActions.setUser(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PointAction);
